/*
*   File : check-box.js
*   Author : https://evoqins.com
*   Description :  Check box component
*   Integrations : NA
*   Version : 1.0.0
*/

import React from 'react';

//Custom components
import { Icon } from '../Icon';

const CustomCheckBox = (props) => {
    return (
        <div className={`${props.className} d-flex gap-10px align-items-start`}  >
            <Icon icon={props.checked ? "checkbox-active" : "checkbox"}
                size="16px"
                className='mt-1 cursor-pointer d-flex'
                onClick={props.handleCheck} />
            {
                props.label &&
                <label className={`${props.labelStyle} e-text-slate-gray e-font-14 e-alt-font-lato e-font-weight-400 line-height-24px`}>
                    {props.label}
                </label>
            }
        </div>
    )
}

export default CustomCheckBox;
